export { default } from './InfoIcon';
export * from './InfoIcon.types';
